import { memo } from "react";
import { useAuthProvider } from "react-admin";

const Dashboard = () => {
  const authDecoded = useAuthProvider().getDecoded();

  if (null === authDecoded) {
    return (<>Wrong Login Session</>);
  }

  return (
    <div>
      <h2>Dashboard</h2>
    </div>
  )
};

export default memo(Dashboard);
